import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ICurrentLeaveSummary } from '../ICurrentLeaveSummary';

export const getSummary = createAction(
  '[CurrentLeaveSummary/API] Get Current Leave Summary',
   props<{ employeeListID: string }>()
);

export const putSummary = createAction(
  '[CurrentLeaveSummary/API] PUT Current Leave Summary',
  props<{ summary: Array<ICurrentLeaveSummary>}>()
);

export const loadCurrentLeaveSummarys = createAction(
  '[CurrentLeaveSummary/API] Load CurrentLeaveSummarys',
  props<{ currentLeaveSummarys: ICurrentLeaveSummary[] }>()
);

export const addCurrentLeaveSummary = createAction(
  '[CurrentLeaveSummary/API] Add CurrentLeaveSummary',
  props<{ currentLeaveSummary: ICurrentLeaveSummary }>()
);

export const upsertCurrentLeaveSummary = createAction(
  '[CurrentLeaveSummary/API] Upsert CurrentLeaveSummary',
  props<{ currentLeaveSummary: ICurrentLeaveSummary }>()
);

export const addCurrentLeaveSummarys = createAction(
  '[CurrentLeaveSummary/API] Add CurrentLeaveSummarys',
  props<{ currentLeaveSummarys: ICurrentLeaveSummary[] }>()
);

export const upsertCurrentLeaveSummarys = createAction(
  '[CurrentLeaveSummary/API] Upsert CurrentLeaveSummarys',
  props<{ currentLeaveSummarys: ICurrentLeaveSummary[] }>()
);

export const updateCurrentLeaveSummary = createAction(
  '[CurrentLeaveSummary/API] Update CurrentLeaveSummary',
  props<{ currentLeaveSummary: Update<ICurrentLeaveSummary> }>()
);

export const updateCurrentLeaveSummarys = createAction(
  '[CurrentLeaveSummary/API] Update CurrentLeaveSummarys',
  props<{ currentLeaveSummarys: Update<ICurrentLeaveSummary>[] }>()
);

export const deleteCurrentLeaveSummary = createAction(
  '[CurrentLeaveSummary/API] Delete CurrentLeaveSummary',
  props<{ id: string }>()
);

export const deleteCurrentLeaveSummarys = createAction(
  '[CurrentLeaveSummary/API] Delete CurrentLeaveSummarys',
  props<{ ids: string[] }>()
);

export const clearCurrentLeaveSummarys = createAction(
  '[CurrentLeaveSummary/API] Clear CurrentLeaveSummarys'
);
